// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const Section: MarkdocTagRegistration = {
  tag: 'section',
  component: 'Section',
  attributes: {
    badges: {
      type: Array,
      required: false,
      description:
        'Pass in an array of strings to add badges to the section headers.',
      localizable: true,
    },
    collapsable: {
      type: Boolean,
      required: false,
      default: true,
      description:
        'Set to false if the section should not be able to be collapsed.',
    },
    numbered: {
      type: Boolean,
      default: true,
      required: false,
      description: 'Shows numbers next to the section headers.',
    },
    optional: {
      type: Boolean,
      required: false,
      default: false,
      description:
        "If true, will display text that says 'Optional' instead of a number and have the section be closed by default.",
    },
    title: {
      type: String,
      required: false,
      description: 'This is the header of the section.',
      localizable: true,
    },
  },
};
